export default __webpack_public_path__ + "static/pig03-7bb0e5fa87a44503039ad30b4e830a2c.png";